// src/context/PublicContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import { collection, onSnapshot, doc } from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { 
  SEED_PORTAFOLIO, SEED_TESTIMONIOS, SEED_SERVICIOS, 
  SEED_CONFIG_NEGOCIO, SEED_CONFIG_APARIENCIA, SEED_CONFIG_SEO 
} from '../utils/seedData';

const PublicContext = createContext();

export function PublicProvider({ children }) {
  const [portafolio, setPortafolio] = useState(SEED_PORTAFOLIO);
  const [testimonios, setTestimonios] = useState(SEED_TESTIMONIOS);
  const [servicios, setServicios] = useState(SEED_SERVICIOS);
  
  const [configNegocio, setConfigNegocio] = useState(SEED_CONFIG_NEGOCIO);
  const [configApariencia, setConfigApariencia] = useState(SEED_CONFIG_APARIENCIA);
  const [configSEO, setConfigSEO] = useState(SEED_CONFIG_SEO);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let unsubs = [];

    // 1. Portafolio
    unsubs.push(
      onSnapshot(collection(db, 'cms_portafolio'), (snap) => {
        if(!snap.empty) setPortafolio(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      })
    );

    // 2. Testimonios
    unsubs.push(
      onSnapshot(collection(db, 'cms_testimonios'), (snap) => {
        if(!snap.empty) setTestimonios(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      })
    );

    // 3. Servicios
    unsubs.push(
      onSnapshot(collection(db, 'cms_servicios'), (snap) => {
        if(!snap.empty) setServicios(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      })
    );

    // 4. Config
    unsubs.push(
      onSnapshot(doc(db, 'cms_configuracion', 'global'), (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.negocio) setConfigNegocio(data.negocio);
          if (data.apariencia) setConfigApariencia(data.apariencia);
          if (data.seo) setConfigSEO(data.seo);
        }
        setLoading(false); // Consider loading done when config arrives
      })
    );

    return () => unsubs.forEach(u => u());
  }, []);

  const value = {
    portafolio,
    testimonios,
    servicios,
    configNegocio,
    configApariencia,
    configSEO,
    loading
  };

  return <PublicContext.Provider value={value}>{children}</PublicContext.Provider>;
}

export function usePublic() {
  return useContext(PublicContext);
}
